import { useEffect, useState } from 'react';
import { getCompanySettings, PCP_OFFICIAL_WHATSAPP } from '@/services/finances';
import { preloadBrandLogo, type BrandLogo } from '@/lib/brandAssets';

// Identidad de marca centralizada: nombre, contacto, logo (ya precargado como
// imagen lista para el PDF) y datos del remitente. Se usa en los modales de
// Pedido/Venta, el comprobante y las descargas de guía de envío, para no
// repetir la carga de configuración en cada punto.
export interface BrandIdentity {
  companyName: string;
  companyPhone: string;
  companyCity: string;
  companyAddress: string;
  companyLogoUrl: string;
  logo: BrandLogo | null;
  senderName: string;
  senderId: string;
  senderPhone: string;
  senderAddress: string;
  senderCity: string;
}

const FALLBACK: BrandIdentity = {
  companyName: 'PCP - Paticas con Propósito',
  companyPhone: PCP_OFFICIAL_WHATSAPP,
  companyCity: 'Bogotá D.C.',
  companyAddress: '',
  companyLogoUrl: '',
  logo: null,
  senderName: '',
  senderId: '',
  senderPhone: '',
  senderAddress: '',
  senderCity: '',
};

export function useBrandIdentity(): BrandIdentity {
  const [identity, setIdentity] = useState<BrandIdentity>(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    getCompanySettings()
      .then(async (s) => {
        if (cancelled) return;
        // El logo se precarga aquí (async) para que la descarga posterior sea
        // totalmente síncrona y conserve el gesto del usuario.
        const logo = s.companyLogoUrl ? await preloadBrandLogo(s.companyLogoUrl) : null;
        if (cancelled) return;
        setIdentity({
          companyName: s.companyName || FALLBACK.companyName,
          companyPhone: s.contactWhatsapp || FALLBACK.companyPhone,
          companyCity: s.companyCity || FALLBACK.companyCity,
          companyAddress: s.companyAddress || '',
          companyLogoUrl: s.companyLogoUrl || '',
          logo,
          senderName: s.senderName || '',
          senderId: s.senderId || '',
          senderPhone: s.senderPhone || '',
          senderAddress: s.senderAddress || '',
          senderCity: s.senderCity || '',
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return identity;
}